import { httpClient } from '../../../services/http/httpClient.js';
import { ensureSuccessPayload, getCollection } from '../../../services/tasks/serviceUtils.js';

const AUTO_OPTIMIZE_CONFIGURATIONS_API_URL = '/api/auto-optimize-configurations';

export const autoOptimizeConfigService = {
  getConfigurations: async () => {
    const payload = ensureSuccessPayload(
      await httpClient.get(AUTO_OPTIMIZE_CONFIGURATIONS_API_URL),
      'No se pudieron obtener las automatizaciones.'
    );
    return getCollection(payload, ['responses']);
  },

  createConfiguration: async (configData) => {
    return ensureSuccessPayload(
      await httpClient.post(AUTO_OPTIMIZE_CONFIGURATIONS_API_URL, { data: configData }),
      'No se pudo crear la automatización.'
    );
  },

  updateConfiguration: async (day, teamsKey, configData) => {
    return ensureSuccessPayload(
      await httpClient.put(
        `${AUTO_OPTIMIZE_CONFIGURATIONS_API_URL}/${encodeURIComponent(day)}/${encodeURIComponent(teamsKey)}`,
        { data: configData }
      ),
      'No se pudo actualizar la automatización.'
    );
  },

  deleteConfiguration: async (day, teamsKey) => {
    return ensureSuccessPayload(
      await httpClient.delete(
        `${AUTO_OPTIMIZE_CONFIGURATIONS_API_URL}/${encodeURIComponent(day)}/${encodeURIComponent(teamsKey)}`
      ),
      'No se pudo eliminar la automatización.'
    );
  }
};
